import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function LinearGradient(_ref) {
  let {
    children,
    id,
    from,
    to,
    x1: _x1,
    y1: _y1,
    x2: _x2,
    y2: _y2,
    fromOffset = '0%',
    fromOpacity = 1,
    toOffset = '100%',
    toOpacity = 1,
    rotate,
    transform,
    vertical = true,
    ...restProps
  } = _ref;
  let x1 = _x1;
  let x2 = _x2;
  let y1 = _y1;
  let y2 = _y2;
  if (vertical && !x1 && !x2 && !y1 && !y2) {
    x1 = '0';
    x2 = '0';
    y1 = '0';
    y2 = '1';
  }
  return /*#__PURE__*/_jsx("defs", {
    children: /*#__PURE__*/_jsxs("linearGradient", {
      id: id,
      x1: x1,
      y1: y1,
      x2: x2,
      y2: y2,
      gradientTransform: rotate ? `rotate(${rotate})` : transform,
      ...restProps,
      children: [!!children && children, !children && /*#__PURE__*/_jsx("stop", {
        offset: fromOffset,
        stopColor: from,
        stopOpacity: fromOpacity
      }), !children && /*#__PURE__*/_jsx("stop", {
        offset: toOffset,
        stopColor: to,
        stopOpacity: toOpacity
      })]
    })
  });
}